import { Link } from "react-router-dom"
import { config } from "../config.js"
import { useTranslation } from "react-i18next"

const NotFound = () => {
  const { t } = useTranslation()

  const smileyStyle = {
    transform: "rotate(90deg)",
    fontSize: "2em",
    fontWeight: "bold",
    display: "inline-block",
  }

  return (
    <center>
      <p style={smileyStyle}>:(</p>
      <h1>{config.errors["404"]}</h1>
      <Link to="/">{t("home.title")}</Link>
    </center>
  )
}

export default NotFound
